import { axiosInstance } from "./axiosInstance";

const getUserDetails = (userId) => axiosInstance.get(`user/${userId}/details`).then(res => res?.data)
const getUsersList = ({ page,
    per_page = 1,
    delay = 1,
    search }) => axiosInstance.get(`/users`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)
const updateUserStatus = (data) => axiosInstance.post(`user/change-status`, data)
const removeAgencyCode = (data) => axiosInstance.post(`user/remove-code`, data)
const exportUsers = (data) => axiosInstance.get(`user/export`, data)
const blockFromAgencies = (data) => axiosInstance.post(`user/block-from-agencies`, data)
export { getUserDetails, getUsersList, updateUserStatus, removeAgencyCode, exportUsers, blockFromAgencies }
